<template>
  <div :class="slice.primary.full_width ? 'container-fluid' : 'container'">
    <div class="row" :style="`--link-size: ${linkSize}px`">
      <prismic-rich-text
        :field="title"
        class="page-title d-flex w-100 mb-3"
        :class="textClasses"
        :style="{ color }"
      ></prismic-rich-text>
      <prismic-rich-text
        :field="subtitle"
        class="page-subtitle d-flex w-100"
        :class="textClasses"
        :style="{ color }"
      ></prismic-rich-text>
      <div v-for="(item, index) in slice.items" :key="index" class="col col-12 col-md-4 m-auto">
        <div class="row">
          <div class="col col-12 col-md-6 align-self-center columns-slice-text">
            <prismic-rich-text
              :style="{ color: item.title_color }"
              :field="item.title1"
            ></prismic-rich-text>
            <prismic-rich-text
              :field="item.links"
              class="column-links"
              :style="`--link-color: ${item.link_color};`"
            ></prismic-rich-text>
          </div>
          <div class="col col-12 col-md-6">
            <picture>
              <source
                v-for="{ resolution, size } in imageSizes"
                :key="resolution"
                :media="`(max-width: ${resolution}px)`"
                :srcset="`${item.image.url}&w=${size}&fmt=webp`"
              />
              <img
                width="100"
                height="100"
                :src="item.image.url"
                :alt="item.image.alt"
                class="img-fluid w-100"
              />
            </picture>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      title: '',
      subtitle: '',
      alignText: '',
      color: '#000',
      linkSize: 16,
      imageSizes: [
        { resolution: 300, size: 230 },
        { resolution: 360, size: 285 },
        { resolution: 375, size: 300 },
        { resolution: 414, size: 340 },
        { resolution: 768, size: 515 },
        { resolution: 1920, size: 160 }
      ]
    };
  },
  computed: {
    textClasses() {
      return this.alignText === 'left'
        ? 'justify-content-start'
        : this.alignText === 'right'
        ? 'justify-content-end'
        : 'justify-content-center';
    }
  },
  created() {
    const { primary } = this.slice;

    this.title = primary.title1;
    this.subtitle = primary.subtitle;
    this.alignText = primary.align_text ? primary.align_text : 'center';
    this.color = primary.font_color;
    if (primary.links_size) {
      this.linkSize = primary.links_size;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .column-links a {
    color: var(--link-color);
    font-size: var(--link-size);
  }
  .columns-slice-text {
    @include sm {
      padding: 10px 30px;
    }
  }
}
</style>
